import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

export const getDayDisplay = (startDate: string | undefined) => {
  if (!startDate) return null;
  const formattedDate = format(new Date(startDate), "d 'de' MMMM 'de' yyyy", {
    locale: es,
  });
  return (
    <div className='form-field-row'>
      <i className='pi pi-calendar primary-icon' />
      <span>{formattedDate}</span>
    </div>
  );
};

export const getHourDisplay = (startDate: string | undefined, endDate: string | undefined) => {
  if (!startDate || !endDate) return null;
  const formattedStartTime = format(new Date(startDate), 'HH:mm', { locale: es });
  const formattedEndTime = format(new Date(endDate), 'HH:mm', { locale: es });
  return (
    <div className='form-field-row'>
      <i className='pi pi-clock primary-icon' />
      <span>{formattedStartTime}</span>
      <i className='pi pi-arrow-right primary-icon' />
      <span>{formattedEndTime}</span>
    </div>
  );
};
